import CloseIcon from "@mui/icons-material/Close";
import { TypeSelect } from "../components/Selects";
import { DateTimeInput } from "../components/Inputs";

export function ViewOffsetForm({
  isOpen,
  onClose,
  employeePersonalInformationFullName, setEmployeePersonalInformationFullName,
  employeePersonalInformationId, setEmployeePersonalInformationId,
  referenceDate, setReferenceDate,
  date, setDate,
  hours, setHours,
  type, setType,
  referenceId, setReferenceId,
  dateFrom, setDateFrom,
  dateTo, setDateTo,
  days, setDays,
  reason, setReason,
  files, setFiles,
  viewImage,
}) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Request Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullName"
                    placeholder="Employee"
                    value={employeePersonalInformationFullName}
                    onChange={(e) =>
                      setEmployeePersonalInformationFullName(e.target.value)
                    }
                    style={{ cursor: "not-allowed" }}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Employee Id</div>
                  <div className="info-item-input">
                    <input
                      readOnly={true}
                      type="number"
                      id="employeePersonalInformationId"
                      placeholder="Employee Id"
                      value={employeePersonalInformationId}
                      onChange={(e) =>
                        setEmployeePersonalInformationId(e.target.value)
                      }
                      style={{ cursor: "not-allowed" }}
                    />
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Type</div>
                <div className="info-item-input">
                  <TypeSelect data={type} setData={setType} isView={true} />
                </div>
              </div>
              {type === "Overtime" &&
                <>
                  <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                      <div className="info-item-label">Reference Date</div>
                      <div className="info-item-input">
                        <input
                          id="hours"
                          placeholder="Reference Date"
                          value={referenceDate ? referenceDate.split("T")[0] : ""}
                          readOnly={true}
                        />
                      </div>
                    </div>
                    <div className="popUp-item info-item column">
                      <div className="info-item-label">Date (To Use)</div>
                      <div className="info-item-input">
                        <DateTimeInput date={date} setDate={setDate} isView={true} />
                      </div>
                    </div>
                  </div>
                  <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                      <div className="info-item-label">Hours</div>
                      <div className="info-item-input">
                        <input
                          type="number"
                          id="hours"
                          placeholder="Hours"
                          value={hours}
                          readOnly={true}
                        />
                      </div>
                    </div>
                    <div className="popUp-item info-item column" style={{ visibility: "hidden" }}>
                      <div className="info-item-label">Hours</div>
                      <div className="info-item-input">
                        <input
                          type="number"
                          id="hours"
                          placeholder="Hours"
                          value={hours}
                          readOnly={true}
                        />
                      </div>
                    </div>
                  </div>
                </>
              }
              {type === "Leave" &&
                <>
                  <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                      <div className="info-item-label">Reference Id</div>
                      <div className="info-item-input">
                        <input
                          id="referenceId"
                          placeholder="Reference Id"
                          value={
                            referenceId
                              ? `OS-${referenceId
                                ?.toString()
                                .padStart(6, "0")}`
                              : ""}
                          readOnly={true}
                        />
                      </div>
                    </div>
                    <div className="popUp-item info-item column">
                      <div className="info-item-label">Days</div>
                      <div className="info-item-input">
                        <input
                          type="number"
                          id="days"
                          placeholder="Days"
                          value={days}
                          readOnly={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                      <div className="info-item-label">Date From (To Use)</div>
                      <div className="info-item-input">
                        <DateTimeInput date={dateFrom} setDate={setDateFrom} isView={true} />
                      </div>
                    </div>
                    <div className="popUp-item info-item column">
                      <div className="info-item-label">Date To (To Use)</div>
                      <div className="info-item-input">
                        <DateTimeInput date={dateTo} setDate={setDateTo} isView={true} />
                      </div>
                    </div>
                  </div>
                </>
              }
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "90%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reason}
                    readOnly={true}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="cancel row"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}